<template  >
 <div>
    <div class="btn Pointer btn-outline-info" @click="openModal"  data-toggle="modal"
        data-target="#Modal-Setting">
        <i class="fas fa-list ml-2"></i> 
    </div>
    <!-- Modal -->
<div class="modal fade" id="Modal-Setting" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="Modal-SettingLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header bg-info">
        <h5 class="modal-title text-dark" id="Modal-SettingLabel">انتخاب نوع وام</h5>
        <!-- <button type="button" class="close text-light" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <div class="modal-body text-right">
        <!-- v-for="(item, key) in Vamha" :key="key" -->
        <div v-for="(item, key) in Vamha" :key="key" class="row px-3">
              <div class="col-3"></div>
              <div class="col-12 col-md-6 mt-2 p-2">
                <div class="w-100 border bnp-rounded Netpa-Shadow p-2">
                  <div class="row">
                    <div class="col-6 text-right">
                      <span class="text-secondary">نام تسهیلات: </span>
                      <span class="text-dark font-weight-bold">{{ item.desNoe }}</span>
                    </div>

                    <div class="col-6 text-left">
                      <button v-if="SelectedVam.id != item.id" @click="seLectVam(item)" class="btn NetPa-btn btn-primary" >انتخاب</button>
                      <span v-else class="text-success font-weight-bold"> انتخاب شده <i class="fas fa-check"></i></span>
                    </div>
                    <div class="col-12 mt-1 text-right">
                      <span class="text-secondary"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
      </div>
      <div class="modal-footer">
        <button type="button" @click="$router.go(-1)" class="btn btn-secondary" data-dismiss="modal">انصراف </button>
      </div>
    </div>
  </div>
</div>



    <Panel Title="تنظیمات درخواست وام" Des="در این منو میتوانید تنظیمات مربوط به شرایط درخواست وام و دیگر تنظیمات آنرا در سامانه خود را انجام دهید." :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <div class="row px-3">
      <div class="col-12 col-md-12 mx-md-2 p-md-3">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link text-dark active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true"> تنظیمات کلی </a>
            <a class="nav-item nav-link text-dark" id="nav-zamen-tab" data-toggle="tab" href="#nav-zamen" role="tab" aria-controls="nav-zamen" aria-selected="false">تنظیمات شرایط ضامنین</a>
            <!-- <a class="nav-item nav-link text-dark" id="nav-upload-tab" data-toggle="tab" href="#nav-upload" role="tab" aria-controls="nav-upload" aria-selected="false">تنظیمات شرایط مدارک</a> -->

          </div>
        </nav> 
        <div class="tab-content" id="nav-tabContent">
        
          <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیمات کلی</h6>
              </template>
              <template slot="content">
                <div class="row">
                  <div v-if="IsSetting" class="alert alert-success w-100 text-dark font-weight-bold text-right"> تسهیلات {{ SelectedVam.desNoe }} برای تنظیمات انتخاب شد</div>
                  <div v-else class="alert alert-danger w-100 text-danger font-weight-bold text-right"> برای تسهیلات   {{ SelectedVam.desNoe }} هیچ تنظیماتی انجام نشده</div>

                </div>
                <div class="row">
                <div class="col-md-3 col-12 text-right mt-2">
                    <small> فعال سازی </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" checked id="IsActive" v-model="DataModelSetting.IsActive" />
                        <label class="custom-control-label p-1" for="IsActive">مجوز برای درخواست وام </label>
                      </div>
                    </span>
                  </div>
                    <div class="col-md-3 col-12 text-right mt-2">
                        <small> حداقل میزان درخواست  </small>
                        <input class="form-control mt-2 text-center 3ragham text-danger" :disabled="!EditMode" @keyup="$PutCommatoInput()" dir="ltr" maxlength="20" style="font-size: 16px" type="text" v-model="DataModelSetting.MinMablagh" >
                    </div>
                    <div class="col-md-3 col-12 text-right mt-2">
                        <small> حداکثر میزان درخواست  </small>
                        <input class="form-control mt-2 text-center 3ragham text-danger" :disabled="!EditMode" @keyup="$PutCommatoInput()" dir="ltr" maxlength="20" style="font-size: 16px" type="text" v-model="DataModelSetting.MaxMablagh" >
                    </div>
                    <div class="col-md-3 col-12 text-right mt-2">
                    <small> محاسبات  </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" id="Isformula" :disabled="!EditMode" v-model="DataModelSetting.Isformula" />
                        <label style="font-size: 12px"  class="custom-control-label p-1" for="Isformula">محاسبات مبلغ و تعداد بر اساس فرمول </label>
                      </div>
                    </span>
                  </div>
                </div>
                <div class="row mt-2">
                <div class="col-md-2 col-12 text-right mt-2">
                    <small> حداقل تعداد اقساط درخواستی  </small>
                        <input class="form-control mt-2 text-center text-danger" :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.MinTedad" >
                </div>
                <div class="col-md-2 col-12 text-right mt-2">
                    <small> حداکثر تعداد اقساط درخواستی  </small>
                        <input class="form-control mt-2 text-center text-danger" :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.MaxTedad" >
                </div>
                <div class="col-md-2 col-12 text-right mt-2">
                        <small> حداکثر میزان بدهی از این نوع وام  </small>
                        <input class="form-control mt-2 text-center 3ragham text-danger" :disabled="!EditMode" @keyup="$PutCommatoInput()" dir="ltr" maxlength="20" style="font-size: 16px" type="text" v-model="DataModelSetting.MaxBedeh" >
                </div>
                <div class="col-md-2 col-12 text-right mt-2">
                        <small> حداکثر بودجه ماهیانه</small>
                        <input class="form-control mt-2 text-center 3ragham text-danger" :disabled="!EditMode" @keyup="$PutCommatoInput()" dir="ltr" maxlength="20" style="font-size: 16px" type="text" v-model="DataModelSetting.MaxBodjeMahane" >
                </div>
                <div class="col-md-2 col-12 text-right mt-2">
                    <small>  محدوده درخواست از روز  </small>
                        <input class="form-control mt-2 text-center text-danger"  :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.AzDay" >
                </div>
                <div class="col-md-2 col-12 text-right mt-2">
                    <small> محدوده درخواست تا روز </small>
                        <input class="form-control mt-2 text-center text-danger" :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.TaDay" >
                </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> حداقل سال سابقه عضویت  </small>
                        <input class="form-control mt-2 text-center text-danger" :disabled="!EditMode" dir="ltr" maxlength="3" style="font-size: 16px" type="text" v-model="DataModelSetting.SabeghehOzviyat" >
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> بررسی موجودی حساب </small>
                    <select class="form-control Pointer mt-2" v-model="DataModelSetting.TblNoeIdPas" :disabled="!EditMode" @change="ChangeNoe()">
                      <option :value="-1">-- انتخاب حساب --</option>
                      <option v-for="item in this.Hesabha" :key="item.id" :value="item">
                        <span>{{ item.desNoe }} </span>
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2" v-if="DataModelSetting.TblNoeIdPas != -1 && DataModelSetting.TblNoeIdPas != null">
                    <small>حداقل موجودی حساب </small> {{ $cookies.get('VahedPool') }}
                    <input class="form-control mt-2 text-center 3ragham text-danger" :disabled="!EditMode" style="font-size: 16px" @keyup="$PutCommatoInput()" type="text" v-model="DataModelSetting.MinMojodiPas" />
                  </div>
                  <div class="col-md-3 col-12 text-right mt-2">
                    <small> بارگذاری مدارک </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" id="IsUpload" v-model="DataModelSetting.IsUpload" />
                        <label style="font-size: 12px"  class="custom-control-label p-1" for="IsUpload"> الزام به بارگذاری مدارک </label>
                      </div>
                    </span>
                  </div>
                  <div class="col-md-3 col-12 text-right mt-2">
                    <small> بررسی سفته الکترونیکی  </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" id="IsSafteElectronic" v-model="DataModelSetting.IsSafteElectronic" />
                        <label style="font-size: 12px"  class="custom-control-label p-1" for="IsSafteElectronic"> الزام به بررسی سفته الکترونیکی </label>
                      </div>
                    </span>
                  </div>
                  
                </div>
                <div class="row mt-2">
                  <div class="col-md-6 col-12 text-right mt-2" >
                    <textarea class="form-control text-right mt-3" type="text" :disabled="!EditMode" placeholder="شرایط بارگذاری مدارک" rows="4" v-model="DataModelSetting.DesUpload"></textarea> 
                 </div>
                  <div class="col-md-6 col-12 text-right mt-2">
                    <textarea class="form-control text-right mt-3" type="text" :disabled="!EditMode" placeholder="شرایط دریافت تسهیلات" rows="4" v-model="DataModelSetting.Des"></textarea> 
                  </div>
                </div>
              </template> 
            </net-pa-card>
          </div>

          <div class="tab-pane fade " id="nav-zamen" role="tabpanel" aria-labelledby="nav-zamen-tab">
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیمات شرایط ضامنین </h6>
              </template>
              <template slot="content">
                <button :disabled="!EditMode" v-if="addZamen == false" class="btn btn-success my-2" @click="addZamen = true">اضافه کردن</button>

                <vue-bootstrap4-table :rows="rows" :action="true" :columns="columns" :config="config" :classes="classes" v-if="addZamen == false">
                  <template slot="isOzv" slot-scope="props" >
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input InputText"
                        :checked="props.cell_value"
                        id="checkTest"
                        disabled
                      />
                      <label class="custom-control-label" for="checkTest"></label>
                    </div>
                  </template> 
                  <!-- <template slot="isUpload" slot-scope="props" >
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input InputText"
                        :checked="props.cell_value"
                        id="checkTest"
                        disabled
                      />
                      <label class="custom-control-label" for="checkTest"></label>
                    </div>
                  </template>  -->
                    <template slot="mabAz" slot-scope="props">
                      <p class="text-center">
                        {{ $Comma3ragham(props.row.mabAz) }}
                      </p>
                  </template>
                  <template slot="mabTa" slot-scope="props">
                    <p class="text-center">
                      {{ $Comma3ragham(props.row.mabTa) }}
                    </p>
                  </template>    
                  
                      <template slot="sort-asc-icon">

                        <i class="fa fa-sort-up"></i>
                      </template>
                      <template slot="sort-desc-icon">
                        <i class="fa fa-sort-down"></i>
                      </template>
                      <template slot="no-sort-icon">
                        <i class="fa fa-sort"></i>
                      </template>
                      <template slot="empty-results">
                        <p class="text-right">اطلاعاتی یافت نشد</p>
                      </template>
                      <template slot="Action" slot-scope="props">
                        <a href="javascript:;" class="mr-2 badge" :disabled="!EditMode" @click="OnDelete(props.row);" >
                          <span class="fa fa-trash-alt text-secondary hover-danger" style="font-size: 15px" ></span > 
                        </a>
                  </template>
                    </vue-bootstrap4-table>

                <div v-else id="addAccountBank" >
                  <div class="row mt-2">
                  <div class="col-md-3 col-12 text-right mt-2" >
                    <small>از مبلغ تسهیلات </small> {{ $cookies.get('VahedPool') }}
                    <input class="form-control mt-2 text-center 3ragham text-danger" :disabled="!EditMode" style="font-size: 16px" @keyup="$PutCommatoInput()" type="text" v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz" />
                  </div>
                  <div class="col-md-3 col-12 text-right mt-2" >
                    <small>تا مبلغ تسهیلات </small> {{ $cookies.get('VahedPool') }}
                    <input class="form-control mt-2 text-center 3ragham text-danger" :disabled="!EditMode" style="font-size: 16px" @keyup="$PutCommatoInput()" type="text" v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa" />
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> تعداد ضامنین </small>
                        <input class="form-control mt-2 text-center text-danger" :disabled="!EditMode" dir="ltr" maxlength="1" style="font-size: 16px" type="text" v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad" >
                  </div>
                  <div class="col-md-2 col-12 text-right mt-2">
                    <small> ضامن عضو باشد</small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" id="IsOzv" v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv" />
                        <label style="font-size: 12px"  class="custom-control-label p-1" for="IsOzv"> الزام به بررسی عضویت ضامن </label>
                      </div>
                    </span>
                  </div>
                  <!-- <div class="col-md-2 col-12 text-right mt-2">
                    <small> بارگذاری مدارک ضامن </small>
                    <span class="form-control p-1 mt-1">
                      <div class="custom-control custom-switch text-center">
                        <input type="checkbox" class="custom-control-input InputText" :disabled="!EditMode" id="WwwtblNoeZamenPolicyOnlineIsUpload" v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload" />
                        <label style="font-size: 12px"  class="custom-control-label p-1" for="WwwtblNoeZamenPolicyOnlineIsUpload"> الزام به بارگذاری مدارک ضامن </label>
                      </div>
                    </span>
                  </div> -->
                </div>
                <!-- <div class="row mt-2">
                  <div class="col-md-6 col-12 text-right mt-2" >
                    <textarea class="form-control text-right mt-3" type="text" :disabled="!EditMode" placeholder="شرایط بارگذاری مدارک ضامن" rows="4" v-model="DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload"></textarea> 
                 </div>
                 </div> -->
                </div>
                <div v-if="Isgrid==false && addZamen==true" class="row mt-5">
                        <button :disabled="!EditMode" class="btn btn-success mx-3" @click="submitAddZamen()">ثبت</button>
                        <button  :disabled="!EditMode" class="btn btn-danger " @click="addZamen = false">لغو</button>  
                      </div>
                <div v-if="Isgrid==true && addZamen==true" class="row mt-5">
                  <button :disabled="!EditMode" class="btn btn-success mx-3" @click="addgridZamen()">اضافه به لیست</button>
                  <button  :disabled="!EditMode" class="btn btn-danger " @click="addZamen = false">لغو</button>  
                </div>
              </template> 
            </net-pa-card>
          </div>

          <!-- <div class="tab-pane fade " id="nav-upload" role="tabpanel" aria-labelledby="nav-upload-tab">
            <net-pa-card>
              <template slot="header">
                <h6 class="text-right"><i class="fas fa-list-alt"></i> تنظیمات شرایط مدارک </h6>
              </template>
              <template slot="content">
              </template> 
            </net-pa-card>
          </div> -->
         </div> 
        
    </div> 

    </div>
    <div class="row">
      <div class="col-md-9"></div>
      <div class="col-md-3 col-12">{{ rows.lenght }}
        <button v-if="EditMode " class="btn btn-success w-100" @click="SaveData">ثبت اطلاعات</button>
        <button v-else class="btn btn-warning w-100" @click="EditMode = !EditMode">اصلاح</button>
      </div>
    </div>
 </div>
</template>
<script>
import Panel from '../Tools/NetPa/Panel.vue';
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'

export default {
    components: { Panel,NetPaCard,VueBootstrap4Table },
    data(){
        return{
          rows: [],
          columns: [

            {label:'id',name:'id',visibility:false},
            { label: 'از مبلغ تسهیلات', name: 'mabAz' },
            { label: 'تا مبلغ تسهیلات', name: 'mabTa' },
            { label: 'تعداد ضامنین ', name: 'tedad' },
            { label: 'عضویت ضامن', name: 'isOzv' },
            { label: 'الزام بارگذاری مدارک', name: 'isUpload' ,visibility:false},
            { label: 'شرایط بارگذاری مدارک', name: 'desUpload',visibility:false },
            {
                label: 'عملیات',
                name: 'Action',
                visibility: true,
                },
          ],
          config: {
          pagination: false,
          pagination_info: false,
          per_page_options: [5, 10],
          show_refresh_button: false,
          show_reset_button: false,
          checkbox_rows: false,
          rows_selectable: true,
          card_title: '',
          card_mode: false,
            global_search: {
              placeholder: '  جستجو   ',
              visibility: false,
              case_sensitive: false,
              showClearButton: true,
              searchOnPressEnter: false,
              searchDebounceRate: 1000,
            },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
          addZamen:false,
          EditMode:false,
          Isgrid:false,
            DataModelSetting:{
                IsActive:true,
                MinMablagh: 0,
                MaxMablagh: 0,
                MinTedad: 1 ,
                MaxTedad: 36,
                MaxBedeh: 0,
                MaxBodjeMahane: 0,
                AzDay: 1,
                TaDay: 31,
                IsUpload: false,
                TblNoeIdPas:-1,
                SabeghehOzviyat: 0,
                MinMojodiPas: 0,
                DesUpload:'',
                Des:'',
                IsSafteElectronic: false,
                Isformula: false,
                WwwtblNoeId:0,
                BnpCashDbtblNoeId:0,
                WwwtblNoeZamenPolicyOnline:{
                  MabAz:0,
                  MabTa:0,
                  Tedad:1,
                  IsOzv:true,
                  IsUpload:false,
                  DesUpload:''
                }

            },
            SelectedVam: {},
            IsSetting:false,
            DataAxiosGetNoeVam: {
                ArryfildValue: '',
                Method: 'Post',
                Action: 'RequestVamNew/GetTblNoe',
                Token: this.$session.get('TokenNetPa'),
            },
            DataAxiosSettingVam: {
                ArryfildValue: '',
                Method: 'Post',
                Action: 'RequestVamNew/GetSettingVam',
                Token: this.$session.get('TokenNetPa'),
            },
            DataAxiosZamenPolicy: {
                ArryfildValue: '',
                Method: 'Post',
                Action: 'RequestVamNew/GetZamenPolicyOnline',
                Token: this.$session.get('TokenNetPa'),
            },
            DataAxiosAddZamenPolicy: {
                ArryfildValue: {},
                Method: 'Post',
                Action: 'RequestVamNew/InsZamenPolicy',
                Token: this.$session.get('TokenNetPa'),
            },
            DataAxios_SaveData: {
              ArryfildValue:{},
              Method: 'Post',
              Action: 'RequestVamNew/InsSettingVam',
              Token: this.$session.get('TokenNetPa'),
          },
            Vamha:[],
            Hesabha:[],
            DataAxiosDelete: {
              ArryfildValue: "",
              Method: "Delete",
              Action: "RequestVamNew",
              Token: this.$session.get('TokenNetPa'),
            },
        }
    },
    methods: {
        SaveData(){
          // console.log(this.SelectedVam);
          const WwwtblNoeZamenPolicyOnline=[];
          WwwtblNoeZamenPolicyOnline.push({
            MabAz:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz!="" ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz.replace(/,/g, '').replace(/\./g, ''):0,
            MabTa:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa!=""?this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa.replace(/,/g, '').replace(/\./g, ''):0,
            Tedad:Number(this.DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad),
            IsOzv:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv,
            IsUpload:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload,
            DesUpload:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload
          })

// console.log(typeof(this.DataModelSetting.MinMojodiPas))
          this.DataAxios_SaveData.ArryfildValue.AzDay=Number(this.DataModelSetting.AzDay)
          this.DataAxios_SaveData.ArryfildValue.BnpCashDbtblNoeId=this.DataModelSetting.BnpCashDbtblNoeId
          this.DataAxios_SaveData.ArryfildValue.Des=this.DataModelSetting.Des
          this.DataAxios_SaveData.ArryfildValue.DesUpload=this.DataModelSetting.DesUpload
          this.DataAxios_SaveData.ArryfildValue.IsActive=this.DataModelSetting.IsActive
          this.DataAxios_SaveData.ArryfildValue.IsSafteElectronic=this.DataModelSetting.IsSafteElectronic
          this.DataAxios_SaveData.ArryfildValue.IsUpload=this.DataModelSetting.IsUpload
          this.DataAxios_SaveData.ArryfildValue.Isformula=this.DataModelSetting.Isformula
          this.DataAxios_SaveData.ArryfildValue.TaDay=Number(this.DataModelSetting.TaDay)
          this.DataAxios_SaveData.ArryfildValue.MinTedad=Number(this.DataModelSetting.MinTedad)
          this.DataAxios_SaveData.ArryfildValue.MaxTedad=Number(this.DataModelSetting.MaxTedad)
          this.DataAxios_SaveData.ArryfildValue.SabeghehOzviyat=Number(this.DataModelSetting.SabeghehOzviyat)
          this.DataAxios_SaveData.ArryfildValue.MinMablagh=this.DataModelSetting.MinMablagh!=""? this.DataModelSetting.MinMablagh.replace(/,/g, '').replace(/\./g, ''):0
          this.DataAxios_SaveData.ArryfildValue.MaxMablagh= this.DataModelSetting.MaxMablagh!=""?this.DataModelSetting.MaxMablagh.replace(/,/g, '').replace(/\./g, ''):0
          this.DataAxios_SaveData.ArryfildValue.MaxBedeh= this.DataModelSetting.MaxBedeh!=""?this.DataModelSetting.MaxBedeh.replace(/,/g, '').replace(/\./g, ''):0
          this.DataAxios_SaveData.ArryfildValue.MaxBodjeMahane= this.DataModelSetting.MaxBodjeMahane!=""?this.DataModelSetting.MaxBodjeMahane.replace(/,/g, '').replace(/\./g, ''):0
          this.DataAxios_SaveData.ArryfildValue.MinMojodiPas=this.DataModelSetting.MinMojodiPas!=""? this.DataModelSetting.MinMojodiPas.replace(/,/g, '').replace(/\./g, ''):0
          this.DataAxios_SaveData.ArryfildValue.TblNoeIdPas=this.DataModelSetting.TblNoeIdPas
          this.DataAxios_SaveData.ArryfildValue.WwwtblNoeId=this.DataModelSetting.WwwtblNoeId
          this.DataAxios_SaveData.ArryfildValue.WwwtblNoeZamenPolicyOnline=this.rows.lenght==0 ? WwwtblNoeZamenPolicyOnline : this.rows

          // console.log(WwwtblNoeZamenPolicyOnline);
          // console.log(this.DataAxios_SaveData.ArryfildValue);
          this.$PostData(this.DataAxios_SaveData).then((data) => {
          if (data.status=="OK") {
            this.$mySweetDefault(
                'عملیات موفق',
                'ثبت تنظیمات با موفقیت انجام شد',
                'success',
                2000
            );
            this.EditMode = !this.EditMode
            
          }else{
            this.$mySweetDefault(
                'عملیات ناموفق',
                'ثبت تنظیمات با مشکل مواجه شد',
                'warning',
                2000
            );
            this.EditMode = !this.EditMode
          }

          }).finally(()=>{
            this.GetNoeVam()
          })


        },
        openModal () {
        $('#Modal-Setting').modal('show')
        },
        closeModal (){
        $('#Modal-Setting').modal('hide')
        },
        GetNoeVam() {
            // Object.assign(this.$data, this.$options.data.call(this));

            var formdata = new FormData()
            formdata.append('id', 1)
            this.DataAxiosGetNoeVam.ArryfildValue = formdata
            this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
                // console.log(data);

                this.Vamha = data
            }).finally(()=>{
                this.openModal();
            })
        },
        GetNoePas() {
            var formdata = new FormData()
            formdata.append('id', 2)
            this.DataAxiosGetNoeVam.ArryfildValue = formdata
            this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
                this.Hesabha = data
            })
        },
        seLectVam(data){
            // console.log('/**/*/',data);
            this.closeModal()
            this.SelectedVam = data
            if(this.SelectedVam.id>0){
              this.DataModelSetting.BnpCashDbtblNoeId=this.SelectedVam.bnpCashDbtblNoeId
              this.DataModelSetting.WwwtblNoeId=this.SelectedVam.id
                this.GetSettingVam()
            }
        },
        GetSettingVam(){
          this.rows=[]
            var formdata = new FormData()
            formdata.append('id', this.SelectedVam.id)
            this.DataAxiosSettingVam.ArryfildValue = formdata
            this.$PostFormData(this.DataAxiosSettingVam).then((data) => {
                //this.Vamha = data
                //  console.log('*/*/*/',data);
                if(data!=null){
                    this.IsSetting=true
                    this.EditMode=false
                    this.Isgrid=false

                    this.DataModelSetting.Id=data.id
                    // this.DataModelSetting.WwwtblNoeId=data.wwwtblNoeId
                    // this.DataModelSetting.BnpCashDbtblNoeId=data.bnpCashDbtblNoeId
                    this.DataModelSetting.IsActive=data.isActive
                    this.DataModelSetting.Isformula=data.isformula
                    this.DataModelSetting.IsSafteElectronic=data.isSafteElectronic
                    this.DataModelSetting.MinMablagh= this.$Comma3ragham(data.minMablagh)
                    this.DataModelSetting.MaxMablagh= this.$Comma3ragham(data.maxMablagh)
                    this.DataModelSetting.MinTedad=data.minTedad
                    this.DataModelSetting.MaxTedad=data.maxTedad
                    this.DataModelSetting.MaxBedeh= this.$Comma3ragham(data.maxBedeh)
                    this.DataModelSetting.AzDay=data.azDay
                    this.DataModelSetting.TaDay=data.taDay
                    this.DataModelSetting.MaxBodjeMahane= this.$Comma3ragham(data.maxBodjeMahane)
                    this.DataModelSetting.MinMojodiPas= this.$Comma3ragham(data.minMojodiPas)
                    this.DataModelSetting.SabeghehOzviyat=data.sabeghehOzviyat
                    this.DataModelSetting.Des=data.des
                    this.DataModelSetting.IsUpload=data.isUpload
                    this.DataModelSetting.DesUpload=data.desUpload
                    this.DataModelSetting.TblNoeIdPas=data.tblNoeIdPas

                }
                else{
                    this.IsSetting=false
                    this.EditMode=true
                    this.rows=[]
                    this.Isgrid=true
                  }
            }).finally (()=>{
            var formdata = new FormData()
            formdata.append('id', this.DataModelSetting.Id)
            this.DataAxiosZamenPolicy.ArryfildValue = formdata
            this.$PostFormData(this.DataAxiosZamenPolicy).then((res) => {
              // console.log('*/*/*',res);
              if(res!=null)
              this.rows =res
              else
              this.rows=[]
            }).finally(()=>{
                this.GetNoePas()
              })
            })
        },
        ChangeNoe(){
          // console.log(this.DataModelSetting.TblNoeIdPas);          
          this.DataModelSetting.TblNoeIdPas= this.DataModelSetting.TblNoeIdPas.id;
        },
        submitAddZamen(){
          this.DataAxiosAddZamenPolicy.ArryfildValue.MabAz=this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz!="" ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz.replace(/,/g, '').replace(/\./g, ''):0
          this.DataAxiosAddZamenPolicy.ArryfildValue.MabTa=this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa!=""?this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa.replace(/,/g, '').replace(/\./g, ''):0
          this.DataAxiosAddZamenPolicy.ArryfildValue.Tedad=Number(this.DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad)
          this.DataAxiosAddZamenPolicy.ArryfildValue.IsOzv=this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv
          this.DataAxiosAddZamenPolicy.ArryfildValue.DesUpload=this.DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload
          this.DataAxiosAddZamenPolicy.ArryfildValue.IsUpload=this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload
          this.DataAxiosAddZamenPolicy.ArryfildValue.WwwtblSettingVamOnlineId=this.DataModelSetting.Id
          
          this.$PostData(this.DataAxiosAddZamenPolicy).then((data) => {
          if (data.status=="OK") {
            this.$mySweetDefault(
                'عملیات موفق',
                'ثبت تنظیمات ضمانت با موفقیت انجام شد',
                'success',
                2000
            );
            this.addZamen=false
          }

          }).finally(()=>{
            var formdata = new FormData()
            formdata.append('id', this.DataModelSetting.Id)
            this.DataAxiosZamenPolicy.ArryfildValue = formdata
            this.$PostFormData(this.DataAxiosZamenPolicy).then((res) => {
              if(res!=null)
              this.rows =res
              else
              this.rows=[]
            })
          })
        },
        OnDelete(row) {
          if(this.Isgrid){
            for (let index = 0; index < this.rows.length; index++) {
              
             if(this.rows[index].id==row.id){
              // console.log(row);
              // console.log(this.rows[index]);
                this.rows.splice(index,1)
             }
              
            }
          }else{
            //console.log(row);
          const formData = new FormData()
            formData.append('id', row.id)
            this.DataAxiosDelete.ArryfildValue=formData
                this.$PostFormData(this.DataAxiosDelete).then((data)=>{
                    if (data.status=="OK") {
                      this.$mySweetDefault(
                                'حذف موفق','تنظیمات ضامن با موفقیت حذف شد','success',2000
                            )
                    }
                }).finally(()=>{
                    var formdata = new FormData()
                    formdata.append('id', this.DataModelSetting.Id)
                    this.DataAxiosZamenPolicy.ArryfildValue = formdata
                    this.$PostFormData(this.DataAxiosZamenPolicy).then((res) => {
                      if(res!=null)
                      this.rows =res
                      else
                      this.rows=[]
                    })
          })
          }
      

        },
        addgridZamen(){
          this.rows.push({
            mabAz:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz!="" ? this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabAz.replace(/,/g, '').replace(/\./g, ''):0,
            mabTa:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa!=""?this.DataModelSetting.WwwtblNoeZamenPolicyOnline.MabTa.replace(/,/g, '').replace(/\./g, ''):0,
            tedad:Number(this.DataModelSetting.WwwtblNoeZamenPolicyOnline.Tedad),
            isOzv:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsOzv,
            isUpload:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.IsUpload,
            desUpload:this.DataModelSetting.WwwtblNoeZamenPolicyOnline.DesUpload,
            id:1
          })
          this.addZamen=false
        }
    },
    mounted() {
        this.GetNoeVam()
    },
}
</script>
<style scoped>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 700px;
  }
  .transparent {
    background-color: #fff0 !important;
    border: none !important;
  }
}
.modal-header {
  border-bottom: none;
}
.bg {
  background: rgb(142, 85, 1);
  background: linear-gradient(
    299deg,
    rgba(142, 85, 1, 1) 0%,
    rgba(230, 139, 3, 1) 100%
  );
}
.modal {
  margin-top: 2%;
}
.bg-warning {
  background: #fda82a !important;
}
.bg-Success {
  background: #67b221 !important;
}
.gradiant-back {
  background: rgb(60, 137, 168);
  background: linear-gradient(
    51deg,
    rgba(60, 137, 168, 1) 0%,
    rgba(23, 57, 71, 1) 100%
  );
}
</style>